import e from"../helpers/IssuerListContainer/IssuerListContainer.js";import{TxVariants as r}from"../tx-variants.js";class t extends e{}var s,a,i;s=t,a="type",i=r.dotpay,a in s?Object.defineProperty(s,a,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[a]=i;export{t as default};
//# sourceMappingURL=index.js.map
